import { render, staticRenderFns } from "./EthnicitySelect.vue?vue&type=template&id=a91d88cc&"
import script from "./EthnicitySelect.vue?vue&type=script&lang=js&"
export * from "./EthnicitySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports